var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,attrs:{"id":"brain-images"}},_vm._l((21),function(n){return _c('div',{key:n,staticClass:"brain-wrapper"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(n-1 == _vm.year),expression:"n-1 == year"}],attrs:{"src":_vm.getImgPath(n-1),"alt":_vm.altText[n-1]}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }